import script from "./NewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewDialog.vue?vue&type=style&index=0&id=2d3b0228&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3b0228"]])

export default __exports__